import { render } from "./user-detail.vue?vue&type=template&id=5eedb9ca&scoped=true&ts=true"
import script from "./user-detail.vue?vue&type=script&lang=ts"
export * from "./user-detail.vue?vue&type=script&lang=ts"

import "./user-detail.vue?vue&type=style&index=0&id=5eedb9ca&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eedb9ca"]])

export default __exports__